




import { Component, Mixins, Prop } from 'vue-property-decorator';
import Button from '@/components/Button.vue';
import { BUTTON_ELEMENT_ACTION_TYPES } from '@/models/enums/button-element-action-types.enum';
import { TEXTFIELD_BUTTON_ACTION_TYPES } from '@/models/enums/textfield-button-action-types.enum';
import GoogleMapsMixin from '@/mixins/googleMapsMixin';
import { ANALYTICS_EVENTS } from '@/const/analytics-events';

@Component({
  name: 'button-widget',
  components: {
    Button,
  },
})
export default class ButtonWidget extends Mixins(GoogleMapsMixin) {
  @Prop({ type: Number }) action?:
    | BUTTON_ELEMENT_ACTION_TYPES
    | TEXTFIELD_BUTTON_ACTION_TYPES;
  @Prop({ type: Object }) extra?: {
    tel?: string;
    mailto?: string;
  };
  @Prop({ type: Boolean, default: false }) isRelated!: boolean;

  private async actionHandler() {
    if (!this.action) return;
    if (this.isRelated) {
      switch (this.action) {
        case TEXTFIELD_BUTTON_ACTION_TYPES.GO_TO_MAPS:
          return await this.goToMaps();
        case TEXTFIELD_BUTTON_ACTION_TYPES.SEND:
          return this.callTo();
        default:
          return;
      }
    }

    switch (this.action) {
      case BUTTON_ELEMENT_ACTION_TYPES.GO_TO_MAPS:
        return await this.goToMaps();
      case BUTTON_ELEMENT_ACTION_TYPES.CALL:
        return this.callTo();
      case BUTTON_ELEMENT_ACTION_TYPES.MAIL_TO:
        return this.mailTo();
      default:
        return;
    }
  }

  callTo() {
    if (!this.extra) return;
    this.$mixpanel(ANALYTICS_EVENTS.CONTACT_WITH_COMPANY_INITIATED, {
      medium: 'phone',
    });
    document.location.href = 'tel:' + this.extra?.tel;
  }

  mailTo() {
    if (!this.extra) return;
    this.$mixpanel(ANALYTICS_EVENTS.CONTACT_WITH_COMPANY_INITIATED, {
      medium: 'e-mail',
    });
    document.location.href = 'mailto:' + this.extra?.mailto;
  }
}
